package br.com.texeratx.boardgametimeapp.domain.usecases.games

import br.com.texeratx.boardgametimeapp.data.repository.GameRepository

data class GameOption(
    val id: Long,
    val name: String
)

class GetGamesSimpleUseCase(
    private val repository: GameRepository
) {
    suspend operator fun invoke(): Result<List<GameOption>> {
        return repository.getGames().map { list ->
            list.map { dto -> GameOption(id = dto.id, name = dto.name) }
        }
    }
}
